import { SdAboutInner } from "./sd-about-inner";
import { SdAbout } from "./sdabout";

let sdAbout = angular
  .module("sdApp.sdAbout", ["sdApp.config"])
  .component("sdAboutInner", {
    controller: SdAboutInner,
    templateUrl: "../ServiceDesk/about/sd-about-inner.html",
    transclude: true
  })
  .component("sdAbout", {
    controller: SdAbout,
    templateUrl: "../ServiceDesk/about/sdabout.html",
    transclude: true
  });
export default sdAbout;
